// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from link.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function LinkIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.68 6.097a1 1 0 1 1-1.36 1.466c-.799-.741-1.85-.75-2.655-.028l-3.078 3.592-.079.082a1.544 1.544 0 0 0 0 2.29c.662.614 1.81.68 2.558.107l.09-.077 1.006-1.21a1 1 0 0 1 1.306-.205l.102.074a1 1 0 0 1 .205 1.307l-.074.101-1.058 1.274-.089.095c-1.525 1.415-3.956 1.346-5.406 0-1.442-1.338-1.564-3.607-.152-5.073l.099-.098 3.1-3.615.079-.082c1.576-1.463 3.83-1.463 5.406 0Zm5.172-5.062c1.442 1.338 1.564 3.607.152 5.073l-.1.097-3.118 3.638-.06.06c-1.576 1.463-3.83 1.463-5.406 0a1 1 0 1 1 1.36-1.466c.799.741 1.85.75 2.655.028l3.078-3.592.079-.082a1.544 1.544 0 0 0 0-2.29c-.662-.614-1.81-.68-2.558-.107l-.091.076-1.005 1.211a1 1 0 0 1-1.306.205l-.102-.074a1 1 0 0 1-.205-1.307l.074-.101L9.357 1.13l.089-.095c1.525-1.415 3.956-1.346 5.406 0Z"
      />
    </svg>
  );
}
